import { createApp } from "vue";
import BakerSubscribeApp from "./BakerSubscribeApp.vue";
createApp(BakerSubscribeApp)
    .mount('#baker-subscribe-app')